function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{opacity:0;}.cls-2{fill:none;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Grupo_7211",
  "data-name": "Grupo 7211",
  className: "cls-1"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rect\\xE1ngulo_6347",
  "data-name": "Rect\\xE1ngulo 6347",
  className: "cls-2",
  width: 24,
  height: 24
}));

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M12.587,21.11011H4.56165A2.10221,2.10221,0,0,1,2.46155,19.01V4.99a2.10221,2.10221,0,0,1,2.1001-2.1001H12.587v1H4.56165A1.10154,1.10154,0,0,0,3.46155,4.99V19.01a1.10154,1.10154,0,0,0,1.1001,1.1001H12.587Z"
});

var _ref5 = /*#__PURE__*/React.createElement("polygon", {
  points: "21.538 11.988 16.448 17.078 15.738 16.368 19.618 12.488 7.358 12.488 7.358 11.488 19.618 11.488 15.738 7.598 16.448 6.898 21.538 11.988"
});

var SvgLogout = function SvgLogout(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogout, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logout.0ba7c244.svg";
export { ForwardRef as ReactComponent };